(function ($) {
    $.fn.table = function (o) {
        window.globalTableId = window.globalTableId || 1;
        return new (function ($root, o) {
            o = $.extend({
                template: null,
                data: [],
                pagerContainer: $(".pagination"),
                pagesContainer: $(".pagination-pages"),
                pagesTemplates: {
                    //first: $('<a class="paginate_button first">Первая</a>'),
                    previous: $('<a class="paginate_button previous" aria-label="Previous"><i class="f-icon f-icon--arrow-prev"></i></a>'),
                    number: $('<a class="paginate_button paginate-number__item"></a>'),
                    span: $('<span class="ellipsis">...</span>'),
                    next: $('<a class="paginate_button next"><i class="f-icon f-icon--arrow-next"></i></a>'),
                    //last: $('<a class="paginate_button last">Последняя</a>')
                },
                pageSize: 20,
                page: 1,
                header: null
            }, o);

            var renderedOnPage = null, renderedPage = null, renderedFilter = null, id = $root.attr("id");
            if (!id) $root.attr("id", id = "tbl_" + (window.globalTableId++));

            var renderPageNums = function () {
                if (!o.pagesContainer.length) return;
                var pages = [10, 20, 50];
                var frags = [];

                for (var i = 0; i < pages.length; i++) {
                    var no = pages[i];
                    var $el = $('<a class="dataTables_length__item" href="#' + id + "_onpage=" + no + '">' + no + "</a>");
                    if (renderedOnPage === no) $el.addClass("active");
                    frags.push($el);
                }
                o.pagesContainer.empty().append(frags);
            }

            var GetPageClick = function (hashTail) {
                var ht = $.extend({}, hashTail);
                return function () {
                    changeHash(appendHashParams(ht));
                }
            };

            var renderPages = function (filtered) {
                var pages = Math.ceil(filtered.length / o.pageSize);
                if (pages < 2) {
                    this.empty();
                    return false;
                }

                var frag = [], hashTail = {}, pageId = id + "_page";

                hashTail[pageId] = o.page - 1;

                var $el = o.pagesTemplates.previous.clone();
                if (o.page !== 1)
                    $el.click(GetPageClick(hashTail));
                else
                    $el.addClass('disabled');

                frag.push($el);

                var dots = false,
                    mid = o.page > 3 && o.page < pages - 2 ? -100 : pages >> 1;
                for (var i = 1; i <= pages; i++) {
                    var $e;
                    hashTail[pageId] = i;
                    if (pages > 8) {
                        if (
                            (i === 1) ||
                            (i === pages) ||
                            (i <= 2 && o.page <= 2) ||
                            (i <= o.page + 1 && i >= o.page - 1) ||
                            (i >= pages - 1 && o.page >= pages - 2) ||
                            (i <= mid + 1 && i >= mid - 1)
                        ) {
                            $e = o.pagesTemplates.number.clone().text(i).click(GetPageClick(hashTail));
                            dots = false;
                        } else {
                            if (dots) continue;
                            $e = o.pagesTemplates.span.clone();
                            dots = true;
                        }

                    } else {
                        $e = o.pagesTemplates.number.clone().text(i).click(GetPageClick(hashTail));
                    }

                    if (!dots) {
                        i === o.page && $e.addClass("current");
                    }
                    frag.push($e);
                }

                hashTail[pageId] = o.page + 1;
                $el = o.pagesTemplates.next.clone(); 
                if (o.page < pages)
                    $el.click(GetPageClick(hashTail));
                else
                    $el.addClass('disabled');
                frag.push($el);
                this.empty().append(frag).show();
                return true;
            };

            var renderPage = function () {
                var hash = getHashParams();
                var pageNo = parseInt(hash[id + "_page"]) || 1;
                var filter = hash["filter"] || null;
                var onPage = parseInt(hash[id + "_onpage"]) || o.pageSize;
                //if (pageNo === renderedPage && filter === renderedFilter && onPage === renderedOnPage) return;
                renderedOnPage = o.pageSize = onPage;
                renderedPage = o.page = pageNo;
                renderedFilter = filter;
                var filtered = o.data;
                if (filter)
                    filtered = filtered.filter(new Function("el", "return el." + unescape(filter)));

                var render = filtered.slice((o.page - 1) * o.pageSize, o.page * o.pageSize);

                templates[o.template].every(render, $root.empty());
                renderPageNums();
                renderPages.call($(o.pagerContainer), filtered) && $(o.pagerContainer).show();
            };
            window.addHashChangedEventListener(renderPage);

            if (o.header) {
                o.header.find("[data-sort]").click(function (e) {
                    var target = $(e.target),
                        sorter = target.attr("data-sort"),
                        direction = target.attr("data-direction") || -1;

                    target.attr("data-direction", -direction);

                    o.data = o.data.sort(function (a, b) {
                        return a[sorter] > b[sorter]
                            ? direction
                            : a[sorter] === b[sorter] ? 0 : -direction;
                    });
                    o.page = 1;
                    renderPage();
                });
            }

            renderPage();

        })(this, o);
    };
})(jQuery);
